import { useEffect, useLayoutEffect } from 'react'

// useLayoutEffect on the client (runs before paint, prevents animation flashes),
// useEffect on the server to avoid the SSR warning.
export const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect
